export const AUTHOR_SEED_ID = '000000000000000000000000';

export const NAME_MAP = {
  capricornio:'Capricornio',
  acuario:'Acuario',
  piscis:'Piscis',
  aries:'Aries',
  tauro:'Tauro',
  geminis:'Géminis',
  cancer:'Cáncer',
  leo:'Leo',
  virgo:'Virgo',
  libra:'Libra',
  escorpio:'Escorpio',
  sagitario:'Sagitario'
};

export const EMOJI = {
  capricornio:'♑',
  acuario:'♒',
  piscis:'♓',
  aries:'♈',
  tauro:'♉',
  geminis:'♊',
  cancer:'♋',
  leo:'♌',
  virgo:'♍',
  libra:'♎',
  escorpio:'♏',
  sagitario:'♐'
};

export function authorLabel(t, fallback = 'Autor') {
  if (!t) return fallback;

  const aid = t.authorId;
  const isSeed =
    !aid ||
    aid === AUTHOR_SEED_ID ||
    (typeof aid === 'object' && aid?._id === AUTHOR_SEED_ID);

  if (isSeed) return 'Zodiacus Oficial 🪐';

  if (t.authorFullName) return t.authorFullName;
  if (t.authorName) return t.authorName;
  if (t.createdByName) return t.createdByName;

  if (t.createdBy && (t.createdBy.fullName || t.createdBy.name))
    return t.createdBy.fullName || t.createdBy.name;

  if (t.author && (t.author.fullName || t.author.name))
    return t.author.fullName || t.author.name;

  if (typeof t.author === 'string' && t.author.trim())
    return t.author.trim();

  return fallback;
}

export function normalizeThreadAuthor(t) {
  if (!t) return t;

  const out = { ...t };
  const a = out.authorId;

  if ((out.authorFullName == null || out.authorFullName === '') && a && typeof a === 'object') {
    out.authorFullName = a.fullName || a.name || out.authorFullName;
  }

  if ((out.authorName == null || out.authorName === '') && a && typeof a === 'object') {
    out.authorName = a.fullName || a.name || out.authorName;
  }

  if (!out.authorName && out.createdByName) out.authorName = out.createdByName;
  if (!out.authorFullName && out.authorName) out.authorFullName = out.authorName;

  return out;
}

export function signToColor(sign) {
  const k = (sign || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[^a-z]/g, '');

  switch (k) {
    case 'aries': return '#FF6B6B';
    case 'tauro': return '#7CB342';
    case 'geminis': return '#29B6F6';
    case 'cancer': return '#26A69A';
    case 'leo': return '#FFA726';
    case 'virgo': return '#8D6E63';
    case 'libra': return '#AB47BC';
    case 'escorpio': return '#EF5350';
    case 'sagitario': return '#FFB300';
    case 'capricornio': return '#6D4C41';
    case 'acuario': return '#42A5F5';
    case 'piscis': return '#26C6DA';
    default: return '#DAA520';
  }
}
